import { JOKI } from '../../../JOKI';
import { endpointRequest } from '../../EndpointService/EndpointFunctions';

export async function openDoor(device, params) {
    try {
        await endpointRequest(JOKI, 'cabinet_command', {
            body: JSON.stringify({ deviceCode: device.code, command: 'doorOpen' }),
            contentType: 'Application/JSON',
        });
    } catch (err) {
        console.warn('DoorOpenCommand: "cabinet_command" Endpoint Error', err);
    }
}

export async function closeDoor(device, params) {
    try {
        await endpointRequest(JOKI, 'cabinet_command', {
            body: JSON.stringify({ deviceCode: device.code, command: 'doorClose' }),
            contentType: 'Application/JSON',
        });
    } catch (err) {
        console.warn('DoorCloseCommand: "cabinet_command" Endpoint Error', err);
    }
}

export async function cabinetReboot(device, params) {
    try {
        await endpointRequest(JOKI, 'cabinet_command', {
            body: JSON.stringify({ deviceCode: device.code, command: 'reboot' }),
            contentType: 'Application/JSON',
        });
    } catch (err) {
        console.warn('RebootCommand: "cabinet_command" Endpoint Error', err);
    }
}

export async function maintenanceStart(device, params) {
    try {
        await endpointRequest(JOKI, 'cabinet_command', {
            body: JSON.stringify({ deviceCode: device.code, command: 'maintenanceStart' }),
            contentType: 'Application/JSON',
        });
    } catch (err) {
        console.warn('maintenanceStartCommand: "cabinet_command" Endpoint Error', err);
    }
}

export async function maintenanceEnd(device, params) {
    try {
        await endpointRequest(JOKI, 'cabinet_command', {
            body: JSON.stringify({ deviceCode: device.code, command: 'maintenanceEnd' }),
            contentType: 'Application/JSON',
        });
    } catch (err) {
        console.warn('maintenanceEndCommand: "cabinet_command" Endpoint Error', err);
    }
}

export function provision(device, params) {
    const { provisioningAppUrl } = params.commandParams;
    // eslint-disable-next-line no-undef
    window.open(`${provisioningAppUrl}/${device.id}`);
}
